import * as Yup from "yup";
import { TransType } from "system/translations/types";

export const createEditValidation = (_t: TransType, params: any) => {
  return Yup.object().shape({
    ip: Yup.string().required(_t("required")),
    comment: Yup.string().required(_t("required")),
  });
};
